<template>
  <div>

    <div v-if="error" class="frm-error">{{ error_message }}</div>

    <div v-if="loading" class="col-md-12" style="min-height:300px;">
      <div class="loading"><img src="@/assets/img/loading.gif" alt=""></div>
    </div>    
      
    <template v-else>
      <div class="ficha-extendida">
        <div class="row">
          <div class="col-xs-3">
            <div class="poster">
              <span class="article-recommended cinema-badge" :title=" $t('Recomendado') " v-if="producto.recomendado == 'S'"></span>
              <img v-if="producto.imagen" :src="producto.imagen" :class=" (producto.descatalogado) ? 'descatalogadoImg' : ''">  
            </div>
          </div>

          <div class="col-xs-9"> 
            <h1>{{ producto.titulo }} {{ (producto.edicion) ? ' · ' + producto.edicion : '' }}</h1>
            <div class="row">
              <div class="col-sm-7">
                <div v-if="producto.generos" class="generos">
                  <template v-for="(item, index) in producto.generos">
                    <template v-if="index > 0">, </template>
                    <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: item.categoria }, query: item.query }">{{ item.nombre }}</router-link> 
                  </template>
                </div>
                <div v-if="producto.titulo_original" class="data"><span>{{ $t('Título original') }}:</span> {{ producto.titulo_original }}</div>
                <div v-if="producto.editor" class="data">
                  <span>{{ $t('Distribuidora') }}:</span>
                  <template v-for="(item, index) in producto.editor">
                    <template v-if="index > 0">, </template>
                    <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: item.categoria }, query: item.query }">{{ item.nombre }}</router-link> 
                  </template>
                </div>
                <div v-if="producto.forma" class="data">
                  <span>{{ $t('Forma') }}:</span> 
                  <template v-for="(item, index) in producto.forma">
                    <template v-if="index > 0">, </template>
                    <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: item.categoria }, query: item.query }">{{ item.nombre }}</router-link> 
                  </template>
                </div>
                <div v-if="producto.ano" class="data"><span>{{ $t('Año de producción') }}:</span>
                  <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: producto.ano.categoria }, query: producto.ano.query }">{{ producto.ano.nombre }}</router-link> 
                </div>
                <div v-if="producto.paises" class="data">
                  <span>{{ $t('País de producción') }}:</span>
                  <template v-for="(item, index) in producto.paises">
                    <template v-if="index > 0">, </template>
                    <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: item.categoria }, query: item.query }">{{ item.nombre }}</router-link> 
                  </template>
                </div>
                  
                <div v-if="producto.edad" class="data"><span>{{ $t('Edad') }}:</span> 
                  <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: producto.edad.categoria }, query: producto.edad.query }">{{ producto.edad.nombre }}</router-link>
                </div>
                <div v-if="producto.color" class="data"><span>{{ $t('Color') }}:</span> {{ producto.color }}</div>
                <br>
                <div v-if="producto.formato" class="data"><span>{{ $t('Formato') }}:</span>
                  <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: producto.formato.categoria }, query: producto.formato.query }">{{ producto.formato.nombre.toUpperCase() }}</router-link> 
                </div> 
                
                <div v-if="producto.descatalogado" class="descatalogado">
                  <i class="fa fa-exclamation-triangle"></i>
                  {{ producto.descatalogado }}
                </div>
                <div v-else class="precio">
                  <div :class=" (getLoggedIn && producto.miseleccion) ? 'cantidad green' : 'cantidad' ">{{ toCurrency(producto.precio) }}</div>
                  <div v-if=" miSeleccion "></div>
                  <div v-else>
                    <div v-if="getLoggedIn && !producto.miseleccion" class="carrito">
                      <div class="mt10" v-if=" producto.miseleccion == null "><img src="@/assets/img/loading-mini.gif" ></div>
                      <button v-else class="btn mt10"
                        @click="addToSelection({ id: producto.id, ref: 'ficha_extendida', tipo: producto.tipo, con: contenedor })"><i class="fa fa-cart-arrow-down"></i> {{ $t('Seleccionar') }}</button>
                    </div>
                    <div v-else-if="getLoggedIn && producto.miseleccion" class="carrito">
                      <button class="btn mt10 btn-tertiary"
                        @click="removeFromSelection(producto.id)"><i class="fa fa-cart-arrow-down"></i> {{ $t('Deseleccionar') }}</button>
                    </div>
                    <div v-else class="carrito">
                      <button class="btn mt10"
                        @click="showLoginModal"><i class="fa fa-cart-arrow-down"></i>  {{ $t('Seleccionar') }}</button>
                    </div>
                  </div> 
                </div> 

              </div>
              <div class="col-sm-5">
                <div class="ficha-tecnica">
                  <h4 v-if="producto.formato">{{ producto.formato.nombre }}</h4>
                  <div class="stable">
                    <div v-if="producto.edicion" class="srow">
                      <div class="scell icon">ED </div>
                      <div class="scell">
                        <span class="ft-title">{{ $t('Edición') }}: </span>
                        {{ producto.edicion }}
                      </div>
                    </div> 
                    <div v-if="producto.idiomas" class="srow">
                      <div class="scell icon"><i class="fa fa-comments-o"></i> </div>
                      <div class="scell">
                        <span class="ft-title">{{ $t('Pistas de audio') }}: </span>
                        <template v-for="(item, index) in producto.idiomas">
                          <template v-if="index > 0">, </template>
                          <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: item.categoria }, query: item.query }">{{ item.nombre }}</router-link> 
                        </template>
                      </div>
                    </div> 
                    <div v-if="producto.subtitulos" class="srow">
                      <div class="scell icon"><i class="fa fa-commenting-o"></i> </div>
                      <div class="scell">
                        <span class="ft-title">{{ $t('Subtítulos') }}: </span>
                        <template v-for="(item, index) in producto.subtitulos">
                          <template v-if="index > 0">, </template>
                          <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: item.categoria }, query: item.query }">{{ item.nombre }}</router-link> 
                        </template>
                      </div>
                    </div>
                    <div v-if="producto.sordos" class="srow">
                      <div class="scell icon"><i class="fa fa-deafness"></i> </div>
                      <div class="scell">
                        <span class="ft-title">{{ $t('Subtitulado sordos') }}: </span>
                        <template v-for="(item, index) in producto.sordos">
                          <template v-if="index > 0">, </template>
                          {{ item.nombre }}
                          <!-- <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: item.categoria }, query: item.query }">{{ item.nombre }}</router-link>  -->
                        </template>
                      </div>
                    </div>
                    <div v-if="producto.ciegos" class="srow">
                      <div class="scell icon"><i class="fa fa-audio-description"></i> </div>
                      <div class="scell">
                        <span class="ft-title">{{ $t('Audiodescripción ciegos') }}: </span>
                        <template v-for="(item, index) in producto.ciegos">
                          <template v-if="index > 0"> / </template>
                          {{ item.nombre }}
                          <!-- <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: item.categoria }, query: item.query }">{{ item.nombre }}</router-link>  -->
                        </template>
                      </div>
                    </div>
                    <div v-if="producto.discos" class="srow">
                      <div class="scell icon"><i class="fa fa-circle-o"></i> </div>
                      <div class="scell">
                        <span class="ft-title">{{ $t('Cantidad de discos') }}: </span>
                        {{ producto.discos }}
                      </div>
                    </div>
                    <div v-if="producto.duracion" class="srow">
                      <div class="scell icon"><i class="fa fa-clock-o"></i> </div>
                      <div class="scell">
                        <span class="ft-title">{{ $t('Duración') }}: </span>
                        {{ producto.duracion }}
                      </div>
                    </div>
                    <div v-if="producto.salida" class="srow">
                      <div class="scell icon"><i class="fa fa-calendar"></i> </div>
                      <div class="scell">
                        <span class="ft-title">{{ $t('Fecha de lanzamiento') }}: </span>
                        {{ producto.salida }}
                      </div>
                    </div>
                    <div v-if="producto.codigo" class="srow">
                      <div class="scell icon"><i class="fa fa-barcode"></i> </div>
                      <div class="scell">
                        <span class="ft-title">{{ $t('Código de barras') }}: </span>
                        {{ producto.codigo }}
                      </div>
                    </div>
                  </div>
                </div>        
              </div>
            </div>
          </div>

        </div>

        <template v-if="producto.otras_ediciones">
          <otras-ediciones 
            v-if="producto.otras_ediciones.resultados" 
            :ediciones="producto.otras_ediciones.resultados"
            :otrasEdicionesId.sync="otrasEdicionesId">
          </otras-ediciones>
        </template>

        <div class="row">
          <div class="col-md-12">
            <h2>{{ $t('Sinopsis') }}</h2>
            <p>{{ producto.sinopsis }}</p>
          </div>
        </div>

        <hr>

        <div class="row">
          <div class="col-md-5">
            <h2>{{ $t('Director/a') }}</h2>
            <template v-for="(item, index) in producto.directores">
              <template v-if="index > 0">, </template>
              <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: item.categoria }, query: item.query }">{{ item.nombre }}</router-link> 
            </template>
          </div>
          <div class="col-md-7">
            <h2>{{ $t('Guionista') }}</h2>
            <template v-for="(item, index) in producto.guionistas">
              <template v-if="index > 0">, </template>
              <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: item.categoria }, query: item.query }">{{ item.nombre }}</router-link> 
            </template>
          </div>   
        </div>

        <hr>

        <div class="row">
          <div class="col-md-12">
            <h2>{{ $t('Actor / actriz') }}</h2>
            <template v-for="(item, index) in producto.actores">
              <template v-if="index > 0">, </template>
              <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: item.categoria }, query: item.query }">{{ item.nombre }}</router-link> 
            </template>
          </div>
        </div>

        <hr>

        <div class="row">
          <div class="col-md-5">
            <h2>{{ $t('Género') }}</h2>
            <template v-for="(item, index) in producto.generos">
              <template v-if="index > 0">, </template>
              <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: item.categoria }, query: item.query }">{{ item.nombre }}</router-link> 
            </template>
          </div>
          <div class="col-md-7">
            <h2>{{ $t('Temática') }}</h2>
            <template v-for="(item, index) in producto.tematicas">
              <template v-if="index > 0">, </template>
              <router-link :to="{ name: 'catalogo', params: { language: getLocale, category: item.categoria }, query: item.query }">{{ item.nombre }}</router-link> 
            </template>
          </div>        
        </div>

        <hr v-if="producto.premios">

        <div v-if="producto.premios" class="row">
          <div class="col-md-12">           
            <h2>{{ $t('Premios') }}</h2>
            <p>{{ producto.premios }}</p>
          </div>
        </div>
      
      </div>

    </template> 
  </div>
</template>

<i18n>
{
  "es": {
    "Título original": "Título original",
    "Forma": "Forma",
    "Año de producción": "Año de producción",
    "Distribuidora": "Distribuidora",
    "País de producción": "País de producción",
    "Edad": "Edad",
    "Formato": "Formato",
    "Color": "Color",
    "Fecha de lanzamiento": "Fecha de lanzamiento",
    "Sinopsis": "Sinopsis",
    "Director/a": "Director/a",
    "Guionista": "Guionista",
    "Actor / actriz": "Actor / actriz",
    "Género": "Género",
    "Temática": "Temática",
    "Premios": "Premios",
    "Recomendado": "Recomendado",
    "Audiodescripción ciegos": "Audiodescripción ciegos",
    "Subtítulos": "Subtítulos",
    "Edición": "Edición",
    "Cantidad de discos": "Cantidad de discos",
    "Pistas de audio": "Pistas de audio",
    "Duración": "Duración",
    "Fecha de lanzamiento": "Fecha de lanzamiento",
    "Subtitulado sordos": "Subtitulado sordos",
    "Código de barras": "Código de barras",
    "Seleccionar": "Seleccionar",
    "Deseleccionar": "Deseleccionar"
  },
  "en": {

  },
  "ca": {
    "Título original": "Títol original",
    "Forma": "Forma",
    "Año de producción": "Any de producció",
    "Distribuidora": "Distribuïdora",
    "País de producción": "País de producció",
    "Edad": "Edat",
    "Formato": "Format",
    "Color": "Color",
    "Fecha de lanzamiento": "Data de llançament",
    "Sinopsis": "Sinopsis",
    "Director/a": "Director/a",
    "Guionista": "Guionista",
    "Actor / actriz": "Actor / actriu",
    "Género": "Gènere",
    "Temática": "Temàtica",
    "Premios": "Premis",
    "Recomendado": "Recomanat",
    "Audiodescripción ciegos": "Audiodescripció cecs",
    "Subtítulos": "Subtítols",
    "Edición": "Edició",
    "Cantidad de discos": "Quantitat de discos",
    "Pistas de audio": "Pistes d'àudio",
    "Duración": "Durada",
    "Fecha de lanzamiento": "Data de llançament",
    "Subtitulado sordos": "Subtitulat sords",
    "Código de barras": "Codi de barres",
    "Seleccionar": "Seleccionar"
  }
}
</i18n>

<script>
  import axios from 'axios';
  import { mapGetters } from 'vuex';

  import OtrasEdiciones from './OtrasEdiciones.vue';

	export default {
    components: { OtrasEdiciones },
    props:['productID', 'miSeleccion', 'contenedor'],
		data: () => {
			return{
        producto: "",
        otrasEdicionesId: '',
        loading: false,
        error: false,
        error_message: ''
			}
		},
    created(){
      this.cargarProducto(this.productID);
    },
    mounted(){
    },
    computed: mapGetters(['getLocale', 'getApiUrl', 'getSelectionBus','getLoggedIn', 'getReloadContent']),
    methods:{
      cargarProducto(productID){
        this.showLoading();
        let contenedorQuery = (this.contenedor) ? '&con=' + this.contenedor : '';
        axios.get(this.getApiUrl + this.getLocale + '/cine?id=' + productID + contenedorQuery)
          .then( (respuesta) =>{   
            this.producto = respuesta.data.data.resultados[0];
            //this.$store.commit('setFichaExtendidaSelected', this.producto.miseleccion);
            this.hideLoading(); 
          })  
          .catch( (error) =>{ 
            this.error_message = error.response.data.status + ' ' + error.response.data.msg;
            this.error = true;
            //console.log(JSON.stringify(error));
            this.hideLoading();      
          })  
      },
      addToSelection(obj){ this.$store.dispatch('addToSelection', obj); },
      removeFromSelection(id){ this.$store.dispatch('removeFromSelection', id); },
      showLoginModal(){ this.$store.commit('showModalLogin'); },
      showLoading(){ this.loading = true; },
      hideLoading(){ this.loading = false; },
    },
    watch:{
      getSelectionBus: function(){
        if( !(Object.keys(this.getSelectionBus).length === 0) && !(this.getSelectionBus === Object) ){ 
          if( !(Object.keys(this.producto).length === 0) && !(this.producto === Object) ){
            let id = this.getSelectionBus.id;
            if( this.producto.id == this.getSelectionBus.id ){
              this.producto.miseleccion = this.getSelectionBus.miseleccion;
            }
          }
        }
      },
      getReloadContent: function(newValue){
        if(newValue){
          this.cargarProducto();
        }
      },
      otrasEdicionesId: function(newValue, oldValue){
        if( newValue != this.productID || ( newValue != oldValue && oldValue != 0 ) ){
          this.producto= [];
          this.cargarProducto(newValue)
        }
      }
    }
  }
</script>
